import React, { FC } from "react";
import { Props } from "./types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

// Card Component
/**
 * This component is used for the rendering a card styled container
 */
library.add(faTimes);

const Tag: FC<Props> = (props) => {
    const handleClose = () => {
        props.onClose(props.keyFilter);
    };

    return (
        <div className="flex flex-justify-center p-l-spacer-md p-r-spacer-xs m-r-spacer-xs m-b-spacer-xs fit-content pill-tag">
            <span className="w-max-content">{props.children}</span>
            <span
                className="m-x-spacer-xs cursor-pointer"
                id={props.keyFilter}
                onClick={handleClose}
            >
                <FontAwesomeIcon icon={faTimes} color="#007AFF" />
            </span>
        </div>
    );
};

export default Tag;
